module.exports = __webpack_public_path__ + "img/big.e0b111e9.jpg";